<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <ServerExpressionEditor
          v-model="value.expressions"
          title="Condition"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ServerExpressionEditor from "../../ui/shared/ServerExpressionEditor.vue";

export default {
  name: "ConditionDesigner",

  components: { ServerExpressionEditor },

  props: ["value"],
};
</script>